import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath, valueExist } from 'src/shared/helpers/objHelpers';
export var EmailItem = function (props) {
    var i18n = props.i18n, applicants = props.applicants, email = props.email;
    var emailType = email.emailType, recipient = email.recipient;
    var applicant = (recipient || {}).applicant;
    var applicantReceiver = valueExist(applicant) ? applicants[applicant] : null;
    var description = getPropsByKeyPath(i18n, 'modules.timeline.email.textSending');
    var applicantFullName = applicantReceiver ? "".concat(applicantReceiver.firstName, " ").concat(applicantReceiver.lastName) : null;
    return (_jsx(_Fragment, { children: _jsxs("p", { children: [description.replace('$type', emailType), " ", _jsx("b", { children: recipient.email || applicantFullName })] }) }));
};
